<div class="container" style="margin-top: 6rem;">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body p-4">

                <!-- Cek apakah data pengguna ada dan tampilkan informasi pengguna -->
                <div *ngIf="!showLoginForm && user">
                  <div class="text-center mb-4">
      
                    <ng-container *ngIf="user.user_login === 'google';else second">
                      
                      <div class="mt-3 mb-5 text-center">
                        <h3 style="color:var(--warna-2)">Welcome back, {{ user.name }}</h3>
                      </div>
      
      
                      <div class="rounded-circle mb-3 text-center">
                        <img 
                          [src]="user.photo" 
                          alt="User Photo" 
                          class="rounded-circle" 
                          *ngIf="user.photo" 
                          (error)="handleImageError($event)" 
                          style="width: 7vw;"
                        >
                        <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 4rem; color:var(--warna-2)"></i>
                      </div>
      
                      <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                        <span style="color: var(--warna-2);">{{ getMaskedEmail(user.email) }}</span>
                        <button 
                          (click)="logout2($event)"
                          style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                          <i class="fa fa-times-circle"></i>
                        </button>
                      </div>
      
      
                      <div class="d-grid gap-2">   
                      <button type="button" class="btn btn-outline-secondary" (click)="handleGoogleLogin()">
                      <i class="fab fa-google me-2"></i> Continue with Google
                      </button>
      
                    <div class="text-end">
                      <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                    </div>
                    </div>
      
                    </ng-container>
                    <ng-template #second>
                        <ng-container *ngIf="user.user_login === 'facebook'; else third">
                          <div class="mt-3 mb-5 text-center">
                            <h3 style="color:var(--warna-2)">Welcome back, {{ user.name }}</h3>
                          </div>
      
      
                          <div class="rounded-circle mb-3 text-center">
                            <img 
                              [src]="user.photo" 
                              alt="User Photo" 
                              class="rounded-circle" 
                              *ngIf="user.photo" 
                              (error)="handleImageError($event)" 
                              style="width: 7vw;"
                            >
                            <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 4rem; color:var(--warna-2)"></i>
                          </div>
      
                          <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                            <span style="color: var(--warna-2);">{{ user.name }}</span>
                            <button 
                              (click)="logout2($event)"
                              style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                              <i class="fa fa-times-circle"></i>
                            </button>
                          </div>
      
                          <div class="d-grid gap-2">   
                          <button type="button" class="btn btn-outline-secondary" (click)="loginWithFacebook()">
                          <i class="fab fa-facebook me-2"></i> Continue with Facebook
                          </button>
      
                        <div class="text-end">
                          <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                        </div>
                        </div>
                        </ng-container>
                    </ng-template>  
                    <ng-template #third>

                      <ng-container *ngIf="user.user_login === 'email'">
                      
                        <div class="mt-3 mb-5 text-center">
                          <h3 style="color:var(--warna-2)">Welcome back, {{ user.name }}</h3>
                        </div>
        
        
                        <div class="rounded-circle mb-3 text-center">
                          <img 
                            [src]="user.photo" 
                            alt="User Photo" 
                            class="rounded-circle" 
                            *ngIf="user.photo" 
                            (error)="handleImageError($event)" 
                            style="width: 7vw;"
                          >
                          <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 4rem; color:var(--warna-2)"></i>
                        </div>
        
                        <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                          <span style="color: var(--warna-2);">{{ getMaskedEmail(user.email) }}</span>
                          <button 
                            (click)="logout2($event)"
                            style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                            <i class="fa fa-times-circle"></i>
                          </button>
                        </div>
                        
                      <form  [formGroup]="logForm" (ngSubmit)="masuk()" autocomplete="off">
                      <div class="mb-3">  
                          <div class="input-group">
                          <input type="password" style="display:none">
                          <input 
                          [type]="isPasswordVisible ? 'text' : 'password'" 
                          class="form-control" 
                          id="passlog"
                          formControlName="passlog"
                          [ngClass]="{'is-invalid': submitted && (
                                       hasError(logForm, 'passlog', 'invalidPassword')
                                       )}"
                          placeholder="Password"
                          autocomplete="new-password"
                          >
      
                          <i 
                          class="fa text-secondary" 
                          [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" 
                          (click)="togglePasswordVisibility()" 
                          style="position: absolute; top: 35%; right: 10px; cursor: pointer; z-index: 5;" 
                          aria-hidden="true">
                        </i>
                         </div>
                          <div class="text-danger text-start" *ngIf="submitted">
                          
                          <div *ngIf="hasError(logForm, 'passlog', 'required')">Please enter your password</div>
                          
                          <div *ngIf="errorMessage"> {{ errorMessage }} </div>

                        </div>
                      </div>
                    

                      <div class="d-grid gap-2">   
                          <button type="submit" class="btn btn-primary w-100 mb-3">Continue</button>
        
                          <div class="text-end">
                            <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                          </div>
                      </div>
                    </form>
                     
                    </ng-container>


                    </ng-template>
                  </div>
                </div>

                <!-- ---------------------------------------------------------------------------------------------------------------- -->


          <!-- Form Login Email -->
          <form *ngIf="showLoginForm" [formGroup]="loginForm" (ngSubmit)="onContinueWithEmail()">
            <div class="mt-3 mb-5 text-center">
              <h3 style="color:var(--warna-2)">Log In or Sign Up</h3>
            </div>


            <div class="mb-3">
              <input 
                type="email" 
                class="form-control" 
                id="email" 
                formControlName="email"
                [class.is-invalid]="hasError(loginForm, 'email', 'required') || hasError(loginForm, 'email', 'email')"
                placeholder="Email"
              >
              <div class="invalid-feedback" *ngIf="submitted">
                <div *ngIf="hasError(loginForm, 'email', 'required')">Please enter email</div>
                <div *ngIf="hasError(loginForm, 'email', 'email')">Email is invalid</div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary w-100 mb-3">Continue</button>
          </form>
          <!-- ---------------------------------------------------------------------------- -->

          <div *ngIf="showLoginForm"> 
            <app-login-social>
            </app-login-social>
          </div>
   
        </div>
      </div>
    </div>
  </div>
</div>
